module.exports = __webpack_public_path__ + "static/food-drinks-63b752d54575c35d3efcf96a034269c3.jpg";